"use strict";
var appn;
(function (appn) {
    var burgerMenu;
    (function (burgerMenu_1) {
        function init() {
            extractAndBuildBoxHeaderIconBtns();
            addEvents();
        }
        burgerMenu_1.init = init;
        function addEvents() {
            $('.btn[data-toggle="dropdown"]').on('click', function (event) {
                cleanBurgerMenu($(this).closest('.appn-dropdown-btn').find('ul.dropdown-menu'));
            });
        }
        function extractAndBuildBoxHeaderIconBtns() {
            const boxesWithBurgerMenus = $('.card .card-tools .appn-burger-menu');
            $.each(boxesWithBurgerMenus, function (index, burgerMenu) {
                const dropdownIconBtns = $(burgerMenu).find('ul.dropdown-menu li[data-boxheadericonbtnorder]');
                if (dropdownIconBtns.length === 0)
                    return;
                const cardTools = burgerMenu.closest('.card-tools');
                let iconBtnList = [];
                $.each(dropdownIconBtns, function (index2, iconBtnLi) {
                    const iconBtnOrderValue = $(iconBtnLi).data('boxheadericonbtnorder');
                    if (iconBtnOrderValue) {
                        const iconClass = extractFontAwesomeIconClasses($(iconBtnLi).find('i'));
                        const dataValues = extractDataValues($(iconBtnLi).find('button'));
                        iconBtnList.push({
                            index: Number(iconBtnOrderValue),
                            element: buildBoxIconBtn(iconClass, extractTitleText($(iconBtnLi)), extractActionClasses($(iconBtnLi)), dataValues, extractButtonAttributes($(iconBtnLi).find('button')))
                        });
                    }
                });
                iconBtnList = iconBtnList.sort((a, b) => {
                    return a.index - b.index;
                });
                iconBtnList.forEach((iconBtn, index, original) => {
                    if (iconBtn && iconBtn.element)
                        cardTools.prepend(iconBtn.element);
                });
            });
            appn.tooltip.init();
        }
        function extractTitleText(element) {
            return element.find('span').text();
        }
        function extractActionClasses(element) {
            let buttonOrAtag = element.find('a');
            if (buttonOrAtag.length === 0)
                buttonOrAtag = element.find('button');
            if (buttonOrAtag.length === 0)
                return appn.emptyString;
            const classList = buttonOrAtag.attr('class');
            if (!classList)
                return appn.emptyString;
            const classArr = classList.split(/\s+/);
            let actionClasses = appn.emptyString;
            $.each(classArr, function (index, value) {
                if (value.startsWithIgnoreCase('tooltip') || value.startsWithIgnoreCase('d-flex') || value.startsWithIgnoreCase('justify-content-between') || value.startsWithIgnoreCase('align-items-center'))
                    return true;
                actionClasses += `${value} `;
            });
            return actionClasses;
        }
        function extractButtonAttributes(element) {
            if (!element)
                return;
            return {
                type: element.attr('type'),
                name: element.attr('name'),
                value: element.attr('value')
            };
        }
        function buildBoxIconBtn(icon, hoverText, classes, data = [], buttonAttributes) {
            const boxIcon = document.createElement('i');
            boxIcon.className = icon;
            const button = document.createElement('button');
            button.title = hoverText;
            button.type = 'button';
            button.className = `btn btn-tool ${classes}`;
            if (buttonAttributes) {
                if (buttonAttributes.type)
                    button.type = buttonAttributes.type == 'submit' || buttonAttributes.type == 'reset' ? buttonAttributes.type : 'button';
                if (buttonAttributes.name)
                    button.name = buttonAttributes.name;
                if (buttonAttributes.value)
                    button.value = buttonAttributes.value;
            }
            if (data.length > 0)
                data.forEach((pair) => {
                    button.setAttribute(pair.key, pair.val);
                });
            button.appendChild(boxIcon);
            return button;
        }
        function extractFontAwesomeIconClasses(element) {
            const classList = element.attr('class');
            if (!classList)
                return appn.emptyString;
            const classArr = classList.split(/\s+/);
            let faIconClass = appn.emptyString;
            $.each(classArr, function (index, value) {
                if (value === 'fa')
                    faIconClass += `${value} `;
                if (value === 'fad')
                    faIconClass += `${value} `;
                if (value.startsWithIgnoreCase('fa-'))
                    if (value.containsIgnoreCase('fa-toggle-off'))
                        faIconClass += 'fa-toggle-on ';
                    else if (value.containsIgnoreCase('fa-toggle-on'))
                        faIconClass += 'fa-toggle-off ';
                    else
                        faIconClass += `${value} `;
                if (value.startsWithIgnoreCase('rotate-'))
                    faIconClass += `${value} `;
                if (value.startsWithIgnoreCase('text-'))
                    faIconClass += `${value} `;
            });
            return faIconClass;
        }
        function extractDataValues(element) {
            var _a;
            const dataPairs = [];
            if (element.get(0) === undefined)
                return dataPairs;
            const attributes = (_a = element.get(0)) === null || _a === void 0 ? void 0 : _a.attributes;
            if (!attributes)
                return [];
            $.each(attributes, function (index, attr) {
                if (attr.name.startsWith('data'))
                    dataPairs.push({ key: attr.name, val: attr.value, index: index });
            });
            return dataPairs;
        }
        function cleanBurgerMenu(ul) {
            if (ul.children().length !== ul.find('>li').length)
                return;
            const burgerList = [];
            ul.find('li').each((index, listItem) => {
                const itemType = $(listItem).hasClass('dropdown-divider') ? 'divider' : 'item';
                burgerList.push({
                    item: $(listItem),
                    type: itemType,
                    action: itemType === 'item' ? $(listItem).find('a,button') : undefined,
                    visible: (itemType === 'item' && $(listItem).find('a,button').hasClass('d-none')) || (itemType === 'divider' && $(listItem).hasClass('d-none')) ? false : true
                });
            });
            burgerList.filter((item) => {
                return item.visible === true;
            }).forEach((listItem, index, burgerList) => {
                if (!listItem.visible)
                    return;
                if (listItem.type === 'divider' && index === 0 && listItem.visible) {
                    listItem.item.hideElement();
                    burgerList[index].visible = false;
                    return;
                }
                if (listItem.type === 'divider' && index > 0 && burgerList[index - 1] && burgerList[index - 1].type === 'divider' && burgerList[index - 1].visible) {
                    burgerList[index - 1].item.hideElement();
                    burgerList[index - 1].visible = false;
                }
            });
            appn.log.info('Burger menu has been cleaned.');
        }
    })(burgerMenu = appn.burgerMenu || (appn.burgerMenu = {}));
})(appn || (appn = {}));
